import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'stringStrict'
})
export class StringStrictPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      let strr = this.removeDiacritics(value);
      return strr.replace(/\s+/g, '-').toLowerCase();
    }
    return null;
  }

  removeDiacritics(str) {
    var string = str;
    var mapaAcentosHex = {
      a: /[\xE0-\xE6]/g,
      e: /[\xE8-\xEB]/g,
      i: /[\xEC-\xEF]/g,
      o: /[\xF2-\xF6]/g,
      u: /[\xF9-\xFC]/g,
      c: /\xE7/g,
      n: /\xF1/g
    };

    for (var letra in mapaAcentosHex) {
      var expressaoRegular = mapaAcentosHex[letra];
      string = string.replace(expressaoRegular, letra);
    }
    return string;
  }

}
